export const calculateSizePercent = ({
  size,
  percent,
  minmax = [-1, 5000],
}) => {
  const [min, max] = minmax;
  const s = size * percent / 100;

  if (s <= min) {
    return min;
  }

  if (s >= max) {
    return max;
  }

  return s;
};
